import { render, staticRenderFns } from "./ModalDetalhesCampanha.vue?vue&type=template&id=22acc167&scoped=true&"
import script from "./ModalDetalhesCampanha.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhesCampanha.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetalhesCampanha.vue?vue&type=style&index=0&id=22acc167&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acc167",
  null
  
)

export default component.exports